import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {GenericSettlementItem} from "../../models/generic-settlement-item.model";

@Component({
  selector: 'app-order-settlement-items-list',
  templateUrl: './order-settlement-items-list.component.html',
  styleUrls: ['./order-settlement-items-list.component.scss'],
})
export class OrderSettlementItemsListComponent implements OnInit {
 @Input() items: GenericSettlementItem[];
  @Output() actionCanceledEmitter = new EventEmitter<boolean>();
  constructor() { }

  ngOnInit() {}

  onCancel() {
    this.actionCanceledEmitter.emit(true);
  }

  checkItemType(item: any): string{
    if(item.p24Fee){
      return 'Vetineo'
    } else{
      return 'Klient'
    }

  }
}
